<template>
    <div class="address-dialog">

        <div class="dialog-content">
            <el-form :model="addressForm" label-width="80px" label-position="top" ref="formRef">
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="标签">
                            <el-input v-model="addressForm.label_name" placeholder="请输入地址标签"></el-input>
                            <div class="tag-buttons">
                                <el-button size="mini" @click="addressForm.label_name = item.name"
                                    v-for="(item, index) in tagList" :key="index">{{ item.name }}</el-button>

                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="收货人">
                            <el-input v-model="addressForm.real_name" placeholder="请输入"></el-input>
                            <div class="gender-radio">
                                <el-radio v-model="addressForm.sex" label="1">先生</el-radio>
                                <el-radio v-model="addressForm.sex" label="2">女士</el-radio>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="12">
                        <el-form-item label="联系电话">
                            <el-input v-model="addressForm.mobile" placeholder="请输入" type="text"
                                maxlength="11"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="所在地区">
                            <el-cascader v-model="selectedValue" :clearable="true" :options="options"
                                :show-all-levels="true" @change="handleChange"></el-cascader>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="详细地址">
                    <el-input v-model="addressForm.detail" type="textarea" :rows="3" placeholder="详细地址"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-checkbox v-model="addressForm.is_default">设置默认地址</el-checkbox>
                </el-form-item>
            </el-form>
        </div>
        <div class="dialog-footer">
            <el-button type="primary" size="large" @click="newAddressFn" v-if="isEdit">编辑地址</el-button>

            <el-button type="primary" size="large" @click="newAddressFn" v-else>保存地址</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NewAddress',
    data() {
        return {
            addressForm: {
                label_name: '',
                real_name: '',
                sex: '1',
                mobile: '',
                address_code_province: '',
                address_code_city: '',
                address_code_district: '',
                detail: '',
                is_default: false,
                aid: ''
            },
            options: [],
            tagList: [],
            selectedValue: []
        }
    },
    props: {
        address: {
            type: Object,
            default: () => { }
        },
        isEdit: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        address: {
            handler(newVal, oldVal) {
                console.log('address变化了:', newVal);
                if (newVal && Object.keys(newVal).length > 0) {
                    // 将监听到的address数据映射到addressForm中
                    this.addressForm = {
                        // 映射现有数据到表单字段
                        real_name: newVal.real_name || '',
                        mobile: newVal.mobile || '',
                        detail: newVal.detail || '',
                        sex: newVal.sex || '1',
                        label_name: newVal.label_name || '',
                        is_default: newVal.is_default == 1 ? true : false,
                        // 设置地区编码
                        address_code_province: newVal.address_code_province || '',
                        address_code_city: newVal.address_code_city || '',
                        address_code_district: newVal.address_code_district || '',
                        aid: newVal.aid || ''
                    };
                    // 级联选择器的值
                    this.selectedValue = [
                        newVal.address_code_province || '',
                        newVal.address_code_city || '',
                        newVal.address_code_district || ''
                    ]
                }
            },
            deep: true,
            immediate: true // 添加immediate选项，确保组件初始化时也能执行
        }
    },
    mounted() {
        this.getAddressTag()
        this.getAreaList();
    },
    methods: {
        handleClose() {
            // 关闭对话框的逻辑
            this.$emit('close');
        },
        handleSave() {
            // 保存地址的逻辑
            this.$emit('save', this.addressForm);
        },

        // 获取地址标签
        getAddressTag() {
            this.$api.getAddressTag().then(res => {
                this.tagList = res;
            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 获取省市区列表
        getAreaList() {
            this.$api.getAreaList().then(res => {
                let list = res;
                this.options = list;
            }).catch(err => {
                this.$message.error(err);

            })
        },

        // 处理级联选择器的change事件
        handleChange(value, label) {
            this.addressForm.address_code_province = value[0];
            this.addressForm.address_code_city = value[1];
            this.addressForm.address_code_district = value[2];
        },

        // 新增收货地址
        newAddressFn() {
            if (!this.addressForm.real_name) {
                this.$message.error('请输入姓名');
                return
            }
            if (!this.addressForm.mobile) {
                this.$message.error('请输入手机号');
                return
            }
            if (!this.addressForm.address_code_province) {
                this.$message.error('请选择省份');
                return
            }
            if (!this.addressForm.address_code_city) {
                this.$message.error('请选择城市');
                return
            }
            if (!this.addressForm.address_code_district) {
                this.$message.error('请选择区县');
                return
            }
            if (!this.addressForm.detail) {
                this.$message.error('请输入详细地址');
                return
            }
            let data = {
                address_id: this.addressForm.aid,
                real_name: this.addressForm.real_name,
                mobile: this.addressForm.mobile,
                detail: this.addressForm.detail,
                sex: this.addressForm.sex,
                label_name: this.addressForm.label_name,
                is_default: this.addressForm.is_default ? '1' : '0',
                // lng: this.datamap.lng,
                // lat: this.datamap.lat,
                province: this.addressForm.address_code_province,
                city: this.addressForm.address_code_city,
                district: this.addressForm.address_code_district
            }
            // console.log(data);
            // return

            // 提交数据到后端
            if (this.isEdit) {
                this.$dapi.editAddressFn(data).then(res => {
                    this.$message.success('编辑收货地址成功');
                    // 发射事件通知父组件
                    this.$emit('addressAdded');
                    this.handleClose();
                    this.resetForm()

                }).catch(err => {
                    this.$message.error(err);
                })
            } else {
                this.$dapi.newAddressFn(data).then(res => {
                    this.$message.success('新增收货地址成功');
                    // 发射事件通知父组件
                    this.$emit('addressAdded');
                    this.handleClose();
                    this.resetForm()

                }).catch(err => {
                    this.$message.error(err);
                })
            }

        },

        // 清空表单
        // 清空表单核心方法
        resetForm() {
            // 1. 重置表单校验状态（关键：必须通过 ref 调用）
            // 重置表单校验状态
            if (this.$refs.formRef) {
                this.$refs.formRef.resetFields();
            }
            // 2. 重置表单数据（resetFields 会恢复到初始值，若初始值非空需手动清空）
            this.addressForm = {
                label_name: '',
                real_name: '',
                sex: '1',
                mobile: '',
                address_code_province: '',
                address_code_city: '',
                address_code_district: '',
                detail: '',
                is_default: false
            },

                // 重置级联选择器的值
                this.selectedValue = [];
        },

    }
}
</script>

<style scoped>
.address-dialog {
    width: 100%;
    background-color: #fff;
    border-radius: 8px;
    /* box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1); */
}

.dialog-header {
    padding: 20px;
    border-bottom: 1px solid #ebeef5;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.dialog-header h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 500;
}

.close-btn {
    padding: 0;
    width: 30px;
    height: 30px;
    line-height: 30px;
    border-radius: 50%;
}

.dialog-content {
    padding: 20px;
    text-align: left;
}

.dialog-content .el-cascader {
    width: 100% !important;
}

.tag-buttons {
    margin-top: 10px;
}

.tag-buttons .el-button {
    margin-right: 10px;
}

.gender-radio {
    margin-top: 10px;
}

.gender-radio .el-radio {
    margin-right: 20px;
}

.dialog-footer {
    padding: 20px;
    border-top: 1px solid #ebeef5;
    text-align: center;
}

.dialog-footer .el-button {
    width: 150px;
}
</style>